<template>
  <v-footer dark height="auto" style="background-color:white">
    <v-card class="flex" flat tile>
      <v-layout align-center justify-center row fill-height v-if="$vuetify.breakpoint.smAndDown">
        <v-btn
          v-for="socialMedia in socialMedias"
          :key="socialMedia.title"
          class="zoom"
          target="_blank"
          :href="socialMedia.to"
          flat
          fab
        >
          <div :class="socialMedia.title"></div>
        </v-btn>
      </v-layout>

      <v-card-actions
        class="justify-center"
        style="background-color:rgba(0, 0, 0, 0.8); opacity:0.5"
      >
        &copy; 2019 —
        <v-btn
          v-if="!user && !userBuffer"
          round
          class="mx-2 text-none"
          @click="dialogLogin = true"
        >{{ title }}</v-btn>
        <span v-else class="mx-2" @click="dialogLogin = true">{{ title }}</span>| Tous droits réservés
      </v-card-actions>
      <v-card-actions
        class="justify-center"
        style="background-color:rgba(0, 0, 0, 0.8);opacity:0.5;height:15px;font-size:10px;padding-top:0px;"
      >
        <div @click="$router.push('/mentions-legales')" style="cursor:pointer">Mentions légales</div>&nbsp;-
        <div
          :class="{'green--text': updatedVersion, 'red--text cursor': !updatedVersion}"
          @click="updateApplication()"
        >&nbsp;Version {{ userVersion }}</div>
        <div class="text-capitalize" v-if="browser">&nbsp;-&nbsp;{{browser}}</div>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Footer",
  props: ["socialMedias"],
  methods: {
    updateApplication() {
      if(this.updatedVersion) return
      this.$store.dispatch("updateApplication");
    }
  },
  computed: {
    ...mapState(["title", "user", "userBuffer", "browser", "version", "userVersion"]),
    updatedVersion() {
      return this.userVersion == this.version ? true : false;
    },
    dialogLogin: {
      get: function() {
        return this.$store.state.dialogLogin;
      },
      set: function(newValue) {
        this.$store.commit("setDialogLogin", newValue);
      }
    }
  }
};
</script>

<style scoped>
.cursor{
  cursor: pointer;
}
</style>
